module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtBAMAAADINP+pAAAAHlBMVEUAAAD////q9fXT6+u74OCu29sbraxPubh0xcSh1tX718wsAAAABnRSTlMAABll4Pjgs5+NAAAAP0lEQVQ4y2NgGAZAEAQkOzo6wQwBVHGJtLSMYSauGgoE4Wlp6SA6VAEubpaGDAwGXHy4hj9ecZHQ0BA08WEIAEXfUO87aNuhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/groups/group_icon_toolbar_request_blue.png
// module id = 841
// module chunks = 0